import Component from 'gia/Component'
import _each from 'lodash.foreach'
import gsap from 'gsap'
import { ScrollTrigger } from "gsap/ScrollTrigger.js";
gsap.registerPlugin(ScrollTrigger);
import { SplitText } from 'gsap/SplitText.js'
gsap.registerPlugin(SplitText);


class Menu extends Component {

  constructor(element) {

    super(element)

    this.body = $('body')
    this.html = $('html')
    this.menu = $('.menu')
    this.element = element
    this.el = $(element)
    this.index = 0


   

  }

  mount() {

    //  _each($('[data-color]'), (el) => {
    //      ScrollTrigger.create({
    //          trigger: el,
    //          start: "top 1%",
    //          onToggle: (self) => {
    //              $('body').toggleClass(`menu-color-${el.dataset.color}`)
    //          }
    //      });
    //  })

     

    
}


  unmount() {




  }


}

module.exports = Menu
